module.exports = __webpack_public_path__ + "img/preloader-spinner.b74fc024.svg";